/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getRepoStatus.defs'
export { main as default } from './getRepoStatus.defs'
